import { Component } from '@angular/core';
import {environment} from '../../environments/environment';
import {RouterLink} from '@angular/router';
import {PricingBoxesComponent} from '../pricing-boxes/pricing-boxes.component';

@Component({
  selector: 'app-membership',
  imports: [RouterLink, PricingBoxesComponent],
  templateUrl: './membership.component.html',
  styleUrl: './membership.component.scss'
})
export class MembershipComponent {
  NUM_SPACES = environment.NUM_SPACES
  NUM_CITIES = environment.NUM_CITIES
}
